// Dark equivalents for legacy screen-specific surfaces and accents.
// Light values stay at each call site as CSS variable fallbacks.
export const darkSurfaceTokens = {
  "--orbit-ink-8392ac": "#dce7f2",
  "--orbit-surface-ffffff": "rgb(32 43 53)",
  "--orbit-surface-f8fafd": "rgb(32 43 53)",
  "--orbit-surface-f2f6fc": "rgb(31 42 53)",
  "--orbit-surface-fff3d6": "rgb(32 42 50)",
  "--orbit-surface-dbeafe": "rgb(29 42 53)",
  "--orbit-surface-dcfce7": "rgb(30 43 51)",
  "--orbit-surface-f3e8ff": "rgb(31 41 53)",
  "--orbit-surface-e0e7ff": "rgb(30 41 53)",
  "--orbit-surface-ffedd5": "rgb(32 42 50)",
  "--orbit-surface-e0f2fe": "rgb(30 42 53)",
  "--orbit-surface-fce7f3": "rgb(32 41 52)",
  "--orbit-surface-e2e8f0": "rgb(30 41 52)",
  "--orbit-surface-e8f8f0": "rgb(30 43 52)",
  "--orbit-surface-fff4da": "rgb(32 42 50)",
  "--orbit-surface-fdebec": "rgb(32 42 52)",
  "--orbit-surface-f1ecff": "rgb(31 42 53)",
  "--orbit-surface-f0f2f6": "rgb(31 42 52)",
  "--orbit-surface-eaf2ff": "rgb(31 42 53)",
  "--orbit-surface-eff6ff": "rgb(31 42 53)",
  "--orbit-line-bfdbfe": "rgba(181, 205, 223, 0.18)",
  "--orbit-ink-2563eb": "rgb(150 180 245)",
  "--orbit-surface-f8fafc": "rgb(32 43 53)",
  "--orbit-ink-94a3b8": "#dce7f2",
  "--orbit-surface-fff1f2": "rgb(32 42 52)",
  "--orbit-surface-fff7ed": "rgb(32 43 52)",
  "--orbit-surface-f2f5f9": "rgb(31 42 53)",
  "--orbit-surface-e4f0ff": "rgb(30 42 53)",
  "--orbit-ink-1d63bc": "rgb(147 180 223)",
  "--orbit-ink-d84646": "rgb(236 166 166)",
  "--orbit-surface-e9eff7": "rgb(30 42 53)",
  "--orbit-ink-178342": "rgb(144 195 164)",
  "--orbit-surface-e4f5e8": "rgb(30 42 51)",
  "--orbit-ink-2878e8": "rgb(152 190 244)",
  "--orbit-surface-edf2f8": "rgb(31 42 53)",
  "--orbit-surface-e3f1e9": "rgb(30 42 51)",
  "--orbit-ink-176b45": "rgb(144 184 166)",
  "--orbit-line-a8d9c0": "rgba(181, 205, 223, 0.18)",
  "--orbit-surface-f0edff": "rgb(31 42 53)",
  "--orbit-surface-e9f3ff": "rgb(30 42 53)",
  "--orbit-surface-e7f7f3": "rgb(30 43 52)",
  "--orbit-surface-fff1e7": "rgb(32 42 51)",
  "--orbit-surface-eef2f7": "rgb(31 42 53)",
  "--orbit-surface-fff6de": "rgb(32 42 51)",
  "--orbit-surface-e7f7ef": "rgb(30 43 52)",
  "--orbit-ink-46566f": "#dce7f2",
  "--orbit-surface-f7ddf4": "rgb(32 41 52)",
  "--orbit-surface-ddf3e8": "rgb(30 42 51)",
  "--orbit-surface-fff0cf": "rgb(32 42 50)",
  "--orbit-surface-e5e0ff": "rgb(30 41 53)",
  "--orbit-surface-ffe1e6": "rgb(32 41 51)",
  "--orbit-surface-ede7ff": "rgb(31 41 53)",
  "--orbit-ink-5631c8": "rgb(174 156 229)",
  "--orbit-surface-e8f1ff": "rgb(30 42 53)",
  "--orbit-ink-185fc1": "rgb(144 178 225)",
  "--orbit-ink-456184": "#dce7f2",
  "--orbit-surface-f7f9fc": "rgb(32 43 53)",
  "--orbit-ink-195eb6": "rgb(145 178 220)",
  "--orbit-surface-e9f2ff": "rgb(30 42 53)",
  "--orbit-surface-fff7e6": "rgb(32 43 51)",
  "--orbit-ink-b56800": "rgb(219 183 133)",
  "--orbit-surface-eaf8ef": "rgb(31 43 52)",
  "--orbit-ink-14823b": "rgb(142 195 161)",
  "--orbit-surface-fdecec": "rgb(32 42 52)",
  "--orbit-ink-c62828": "rgb(228 152 152)",
  "--orbit-surface-eef2ff": "rgb(31 42 53)",
  "--orbit-ink-4338ca": "rgb(165 159 230)",
  "--orbit-ink-475569": "#dce7f2",
  "--orbit-ink-4b83e5": "rgb(169 195 243)",
  "--orbit-surface-e5eaf2": "rgb(30 42 52)",
  "--orbit-line-cbd5e1": "rgba(181, 205, 223, 0.18)",
  "--orbit-ink-a45b00": "rgb(211 176 133)",
  "--orbit-ink-1d4ed8": "rgb(147 170 236)",
  "--orbit-ink-15803d": "rgb(143 194 162)",
  "--orbit-ink-7e22ce": "rgb(193 149 231)",
  "--orbit-ink-c2410c": "rgb(226 164 138)",
  "--orbit-ink-0369a1": "rgb(134 183 210)",
  "--orbit-ink-be185d": "rgb(224 144 177)",
  "--orbit-surface-fafcff": "rgb(32 43 53)",
  "--orbit-ink-178554": "rgb(144 196 173)",
  "--orbit-line-cdeedc": "rgba(181, 205, 223, 0.18)",
  "--orbit-ink-b36a08": "rgb(219 183 136)",
  "--orbit-line-f5e4b8": "rgba(181, 205, 223, 0.18)",
  "--orbit-ink-c3434a": "rgb(226 165 168)",
  "--orbit-line-f5d4d7": "rgba(181, 205, 223, 0.18)",
  "--orbit-ink-6c4bc2": "rgb(184 169 226)",
  "--orbit-line-e1d8fa": "rgba(181, 205, 223, 0.18)",
  "--orbit-ink-667085": "#dce7f2",
  "--orbit-line-e3e6ec": "rgba(181, 205, 223, 0.18)",
  "--orbit-ink-2765c2": "rgb(151 181 226)",
  "--orbit-line-d5e4fb": "rgba(181, 205, 223, 0.18)",
  "--orbit-line-0f172a": "rgba(181, 205, 223, 0.18)",
  "--orbit-line-64748b": "rgba(181, 205, 223, 0.18)",
  "--orbit-ink-7c3aed": "rgb(192 160 246)",
  "--orbit-ink-e11d48": "rgb(241 147 167)",
  "--orbit-ink-ea580c": "rgb(245 175 138)",
  "--orbit-line-2878e8": "rgba(181, 205, 223, 0.18)",
  "--orbit-line-dde4ee": "rgba(181, 205, 223, 0.18)",
  "--orbit-ink-c33b3b": "rgb(226 161 161)",
  "--orbit-surface-fdeaea": "rgb(32 42 52)",
  "--orbit-ink-b86b00": "rgb(221 184 133)",
  "--orbit-surface-fff1d4": "rgb(32 42 50)",
  "--orbit-ink-56657b": "#dce7f2",
  "--orbit-surface-edf0f4": "rgb(31 42 52)",
  "--orbit-ink-59616d": "#dce7f2",
  "--orbit-surface-eceef1": "rgb(31 42 52)",
  "--orbit-ink-245dc7": "rgb(150 177 228)",
  "--orbit-surface-e5eeff": "rgb(30 42 53)",
  "--orbit-ink-6b43d4": "rgb(184 165 234)",
  "--orbit-surface-efe9ff": "rgb(31 41 53)",
  "--orbit-ink-5a3ee6": "rgb(176 162 243)",
  "--orbit-ink-0969d8": "rgb(137 183 236)",
  "--orbit-ink-087a67": "rgb(136 191 182)",
  "--orbit-ink-e56a13": "rgb(243 183 142)",
  "--orbit-ink-52647f": "#dce7f2",
  "--orbit-ink-76520b": "rgb(189 172 138)",
  "--orbit-ink-13704a": "rgb(142 186 168)",
  "--orbit-ink-138447": "rgb(142 196 167)",
  "--orbit-ink-d32f2f": "rgb(234 155 155)",
  "--orbit-surface-e8f7ee": "rgb(30 43 52)",
  "--orbit-ink-8c176f": "rgb(200 144 186)",
  "--orbit-line-e9b7df": "rgba(181, 205, 223, 0.18)",
  "--orbit-ink-126d48": "rgb(141 185 167)",
  "--orbit-line-a9dfc9": "rgba(181, 205, 223, 0.18)",
  "--orbit-ink-8a5700": "rgb(199 174 133)",
  "--orbit-line-f4d38e": "rgba(181, 205, 223, 0.18)",
  "--orbit-ink-4930a8": "rgb(168 156 213)",
  "--orbit-line-c7bcf5": "rgba(181, 205, 223, 0.18)",
  "--orbit-ink-9a2540": "rgb(207 150 163)",
  "--orbit-line-f4b5c2": "rgba(181, 205, 223, 0.18)",
  "--orbit-surface-eee9ff": "rgb(31 41 53)",
  "--orbit-surface-e6f3ff": "rgb(30 42 53)",
  "--orbit-ink-6b45d8": "rgb(184 166 236)",
  "--orbit-ink-1681d8": "rgb(143 195 236)",
  "--orbit-ink-c83737": "rgb(229 159 159)",
  "--orbit-surface-e5f7ec": "rgb(30 43 52)",
};
